import { Answers, ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext"


export const shouldCheckDailyActivity = (answers: Answers): boolean => {
    const {children, miscellaneous, chronicIllness, chronicIllnessDetail } = answers

    if (children?.pregnant) {
      return true
    }
  
    if (miscellaneous) {
      const qualifying = [miscellaneous.dementiaOrCognitiveImpairment, miscellaneous.physicalImpairment, miscellaneous.mentalHealthIssue, miscellaneous.recentlyRecoveringFromAHospitalVisit, miscellaneous.learningDifficultiesOrDisablities]
      if (qualifying.some(v => Boolean(v))) {
        return true
      }
    }

    if (chronicIllness && chronicIllness === ConfirmationAnswer.Yes && chronicIllnessDetail) {
      return [chronicIllnessDetail.other].some(v => Boolean(v))
    }
  
    return false
  }